export default __webpack_public_path__ + "static/media/IMG_4610.3df1b804.jpg";